import { render } from "./CuponContenido.vue?vue&type=template&id=593f1d8f&scoped=true"
import script from "./CuponContenido.vue?vue&type=script&lang=js"
export * from "./CuponContenido.vue?vue&type=script&lang=js"

import "./CuponContenido.vue?vue&type=style&index=0&id=593f1d8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593f1d8f"]])

export default __exports__